/**
 * @generated SignedSource<<f1e8f9866c132900612f401dba23262d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MarketingEmailsViewQuery$variables = Record<PropertyKey, never>;
export type MarketingEmailsViewQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"MarketingEmailList_query">;
};
export type MarketingEmailsViewQuery = {
  response: MarketingEmailsViewQuery$data;
  variables: MarketingEmailsViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = [
  (v0/*: any*/),
  (v1/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "MarketingEmailsViewQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "MarketingEmailList_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "MarketingEmailsViewQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MarketingEmail",
        "kind": "LinkedField",
        "name": "marketingEmails",
        "plural": true,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "marketingEmailIdentifier",
            "storageKey": null
          },
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "senderName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "senderEmail",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "recipientCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sentAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "archivedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MailingList",
            "kind": "LinkedField",
            "name": "mailingList",
            "plural": false,
            "selections": (v2/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "EmailTemplate",
            "kind": "LinkedField",
            "name": "emailTemplate",
            "plural": false,
            "selections": (v2/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0bb743367f8d7e1143324c8d6ef55a84",
    "id": null,
    "metadata": {},
    "name": "MarketingEmailsViewQuery",
    "operationKind": "query",
    "text": "query MarketingEmailsViewQuery {\n  ...MarketingEmailList_query\n}\n\nfragment MarketingEmailList_query on Query {\n  marketingEmails {\n    id\n    marketingEmailIdentifier\n    name\n    status\n    senderName\n    senderEmail\n    recipientCount\n    createdAt\n    sentAt\n    archivedAt\n    mailingList {\n      id\n      name\n    }\n    emailTemplate {\n      id\n      name\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e1b84e2e61f8e5b50b91c7cc62b4a5a7";

export default node;
